interface Props {
  type: string
}

export const getExpandedDefault = (props: Props): boolean => {
  const {type} = props

  if (type === 'column') {
    return true
  }

  if (type === 'task') {
    return false
  }

  return false
}
